export const tableHeader = (t) => [
  {
    id: 'name',
    type: 'text',
    value: t('company:offices.table.name'),
  },
  {
    id: 'address',
    type: 'text',
    value: t('company:offices.table.address'),
  },
  {
    id: 'phone',
    type: 'text',
    value: t('company:offices.table.phone'),
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
  },
]
